import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.25 6.757a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M12 4.507a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m-9.75 5.25a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m10.5 1.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-.041 11.25a.75.75 0 0 1-.372.566A12.7 12.7 0 0 1 12 21.757a12.7 12.7 0 0 1-6.337-1.684.75.75 0 0 1-.372-.566h-.04a9.7 9.7 0 0 1-3.24-.552.75.75 0 0 1-.498-.647q-.012-.15-.012-.301a3.75 3.75 0 0 1 5.216-3.452A6.74 6.74 0 0 1 12 12.007c2.14 0 4.047.996 5.283 2.548a3.75 3.75 0 0 1 5.206 3.753.75.75 0 0 1-.499.648 9.7 9.7 0 0 1-3.24.55zm-6.709-6a5.245 5.245 0 0 0-5.25 5.223v.027q0 .103.004.204A11.2 11.2 0 0 0 12 20.258c1.896 0 3.68-.469 5.246-1.296q.004-.101.004-.204v-.027A5.245 5.245 0 0 0 12 13.507m6.095 2.347a6.7 6.7 0 0 1 .614 2.153h.042c.773 0 1.52-.106 2.23-.305a2.25 2.25 0 0 0-2.886-1.849m-12.19 0a2.25 2.25 0 0 0-2.884 1.849 8.3 8.3 0 0 0 2.23.304h.04a6.7 6.7 0 0 1 .614-2.154",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }